var _path, _path2, _circle, _circle2, _circle3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRmPortal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 25.333H6.06061C4.92256 25.333 4 24.2137 4 22.833V7.83301C4 6.4523 4.92256 5.33301 6.06061 5.33301H24.6061C25.7441 5.33301 26.6667 5.8273 26.6667 7.20801V16.583",
    stroke: "#0A80D5",
    strokeWidth: 2.22667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.4785H26.6667",
    stroke: "#0A80D5",
    strokeWidth: 2.22667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23833,
    cy: 8.44634,
    r: 1.11333,
    fill: "#0A80D5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7989,
    cy: 8.44634,
    r: 1.11333,
    fill: "#0A80D5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3575,
    cy: 8.44634,
    r: 1.11333,
    fill: "#0A80D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5414_7107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7012 16.7012L20.9247 24.4386L22.0691 21.0691L25.4386 19.9247L17.7012 16.7012Z",
    stroke: "#0A80D5",
    strokeWidth: 2.22667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2598 21.2598L24.9954 23.9954",
    stroke: "#0A80D5",
    strokeWidth: 2.22667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5414_7107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9427,
    height: 10.9427,
    fill: "white",
    transform: "translate(16.334 15.333)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmPortal);
export default __webpack_public_path__ + "static/media/rm-portal.68bf392599e1be3218d8c448070c9815.svg";
export { ForwardRef as ReactComponent };